/**
 *  get data from json files with some static data
 *  from "static/data" folder
 *
 */
export const JSONpath = function () { // eslint-disable-line
  let hostName = window.location.hostname;
  const host = window.location.host; // eslint-disable-line
  const httpType = window.location.href.split('//')[0];

  if (hostName === 'localhost') {
    hostName = `${host}`;
  }

  return `${httpType}//${hostName}/static`;
};
